<script setup lang="ts">
import { useDialog } from "primevue/usedialog";

import AppSettings from "@/components/AppSettings.vue";

const dialog = useDialog();
const onOpenSettings = (): void => {
  dialog.open(AppSettings, {
    props: {
      header: "App Settings",
      style: {
        width: "75vw",
        "max-width": "75vw",
      },
      breakpoints: {
        "960px": "75vw",
        "640px": "90vw",
      },
      modal: true,
      draggable: false,
    },
  });
};
</script>

<template>
  <div v-tooltip.right="`App Settings`">
    <i
      class="pi pi-cog cursor-pointer text-2xl text-surface-300/50"
      title="Application Settings"
      @click="onOpenSettings"
    />
  </div>
</template>

<style lang="postcss"></style>
